import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=1994a430&scoped=true"
import script from "./Sectors.vue?vue&type=script&lang=js"
export * from "./Sectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994a430",
  null
  
)

export default component.exports